"use strict";
exports.__esModule = true;
exports.EMBED_QR_CODE = void 0;
exports.EMBED_QR_CODE = {
    BODY: 'Scan to download.'
};
